exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".imagenpersonalizada:hover{transition-duration:3s;transform:rotate(1turn)}nav.side-navbar span{display:initial}nav.side-navbar .sidenav-header{background:#fff}nav.side-navbar .sidenav-header img{width:100px;height:auto}nav.side-navbar .sidenav-header a:hover{background-color:transparent!important}imagen{width:50px;height:18.462px}ul>li>a:hover{text-decoration:none}.cards{box-shadow:1px 5px 7px 5px rgba(0,0,0,.1);border-left-width:0;padding:15px 50px 30px 55px;border-bottom-width:30px;border-color:15px gray}.textb{color:#fff;font-size:18px}.menu{margin-top:100px;padding:5px}.menu:hover{background-color:#aed6f1}.navbar-custom{background-color:#024464}.sidemenu{height:900px}.listado{padding-right:0}.contenido{padding-left:0}.logo{width:10%;height:5%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29715734","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/nav.vue
// module id = 396
// module chunks = 0